module.exports = __webpack_public_path__ + "img/workspace-onboarding/share-your-video-0368b931c39654fd40b07650e67c89ad.png";